import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  icon: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    position: 'absolute',
    left: '8px',
    bottom: '16px',
    zIndex: 100,
    fontDefault: 10,
    color: colors.white,
    flexDirection: 'row',
    paddingLeft: '4px',
    paddingRight: '4px',
    paddingTop: '3px',
    paddingBottom: '3px',
    borderRadius: '4px',
    background: colors.blueCrush80,
    userSelect: 'none',
    lineHeight: '1.42em',
  },
  icon: {
    marginRight: '4px',
  },
});

export default styles;
